// LanguageSelector Component
// src/components/LanguageSelector.js
import React from 'react';
import { useDispatch } from 'react-redux';
import { changeLanguage } from '../../Store/actions/languageActions';
import store from '../../Store/store';

const LanguageSelector = () => {
    const dispatch = useDispatch();

    const handleLanguageChange = (e) => {
        dispatch(changeLanguage(e.target.value));
    }

}

export default LanguageSelector;